import { GlobalSearchResult, GlobalSearchResultType } from 'GlobalSearchResult';

export const DEFAULT_SELECTED_SEARCH_TYPES: string[] = [];

export const SEARCH_TYPE_FILTER_OPTIONS = [
  'CONTACT',
  'FUND_OPPORTUNITY',
  'ADMIN_USER',
  'INVESTMENT_ENTITY',
  'ARTICLE',
];

export const SEARCH_TYPE_LABEL_MAP: Record<string, string> = {
  '': 'Any',
  CONTACT: 'Contact',
  FUND_OPPORTUNITY: 'Fund Opportunity',
  ADMIN_USER: 'Admin User',
  INVESTMENT_ENTITY: 'Investment Entity',
  ARTICLE: 'Article',
};

export function mapToSearchTypes(modelTypes: string[]): GlobalSearchResultType[] {
  const mapping: Record<string, GlobalSearchResultType | null> = {
    CONTACT: 'Contact',
    FUND_OPPORTUNITY: 'FundOpportunity',
    INVESTOR: 'Investor',
    ADMIN_USER: 'AdminUser',
    INVESTMENT_ENTITY: 'InvestmentEntity',
    ARTICLE: 'Article',
  };
  const mapped = modelTypes.map((t) => mapping[t]).filter((v): v is GlobalSearchResultType => !!v);
  if (mapped.length === 0 && modelTypes.length === 0) {
    return ['Contact', 'FundOpportunity', 'InvestmentEntity', 'Article', 'AdminUser'];
  }
  return mapped;
}

export function getTypeFilterLabel(selectedTypes: string[]): string {
  return selectedTypes.length === 0
    ? 'Any'
    : selectedTypes.length === 1
      ? SEARCH_TYPE_LABEL_MAP[selectedTypes[0]] || 'Any'
      : 'Multiple';
}

export function toggleSelectedSearchType(current: string[], value: string): string[] {
  if (value === '__ANY__') {
    return [];
  }
  if (current.includes(value)) {
    return current.filter((t) => t !== value);
  }
  return [...current, value];
}

export function getNextSearchResultIndex(selectedIndex: number, resultsLength: number): number {
  return selectedIndex < resultsLength - 1 ? selectedIndex + 1 : 0;
}

export function getPreviousSearchResultIndex(selectedIndex: number, resultsLength: number): number {
  return selectedIndex > 0 ? selectedIndex - 1 : resultsLength - 1;
}

export function getNavigationPathForSearchResult(result: GlobalSearchResult): string | null {
  switch (result.type) {
    case 'FundOpportunity':
      return `/opportunities/${result.id}`;
    case 'Contact':
      return `/contacts/${result.id}`;
    case 'AdminUser':
      return `/adminUsers/${result.id}`;
    case 'InvestmentEntity':
      return `/entities/${result.id}`;
    default:
      return null;
  }
}
